import React from 'react';

type LinkifyTextOptions = {
  match: string;
  href: string;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
};

const PrivacyPolicyLink = ({ text, options }: { text: string; options: LinkifyTextOptions }) => {
  const { match, href, target = '_self', rel } = options;

  if (!text.includes(match)) {
    return text;
  }

  const parts = text.split(match);

  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index < parts.length - 1 && (
            <a href={href} target={target} rel={rel} className="v2-underline">
              {match}
            </a>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default PrivacyPolicyLink;
